import { convert } from 'util/unitConversion';
import { UNIT_TYPES } from 'constants/unitTypes';
import { managementZonesTypes } from 'constants/scripts';
import { get, set } from 'lodash';

export const formatAdvancedRequestBody = ({ templateParams, cropId, cropNominalWeight }) => {
  const { plantingPlanParams } = templateParams;

  plantingPlanParams['target-yield'] = convert({
    from: {
      'q': plantingPlanParams['target-yield'],
      'u': UNIT_TYPES.bu_ac
    },
    to: { u: UNIT_TYPES.kilogram_hectare},
    cropNominalWeight
  });

  plantingPlanParams['price-commodity'] = convert({
    from: {
      'q': plantingPlanParams['price-commodity'],
      'u': UNIT_TYPES.usd_bu
    },
    to: { u: UNIT_TYPES.usd_kg}
  });

  plantingPlanParams['price-product'] = convert({
    from: {
      'q': plantingPlanParams['price-product'],
      'u': UNIT_TYPES.usd_bag
    },
    to: { u: UNIT_TYPES.usd_thousand}
  });

  return {
    'layers': [
      {
        'name': 'auto',
        'generation-args': plantingPlanParams
      }
    ],
    'attributes': {
      'crop-id': cropId.toString()
    }
  };
};

const importedMapsManualRequestBody = ({ cropId, templateParams }) => {
  const { managementZonesId } = templateParams;
  return {
    'layers': [
      {
        'name': 'existing-fmz',
        'generation-args': { 'fmz-id': managementZonesId }
      }
    ],
    'attributes': {
      'crop-id': cropId ? `${cropId}` : undefined
    }
  };
};

const defaultManualRequestBody = ({ cropId, templateParams }) => {
  const managementZonesId = get(templateParams, 'managementZonesId', 'ssurgo'); // default to ssurgo zones id not available
  const baseRequest = {
    'layers': [
      {
        'name': managementZonesId,
        'merge-attributes': ['parsed-muname']
      }
    ],
    'attributes': {}
  };

  if (cropId) {
    set(baseRequest, 'attributes.crop-id', cropId.toString());
  }

  return baseRequest;
};

export const formatManualRequestBody = ({ cropId, templateParams }) => {
  const managementZonesType = get(templateParams, 'managementZonesType', '');
  switch (managementZonesType) {
    case managementZonesTypes.IMPORTED_MAPS:
    case managementZonesTypes.IMPORTED_MAPS_PARENT:
      return importedMapsManualRequestBody({ cropId, templateParams });
    default:
      return defaultManualRequestBody({ cropId, templateParams });
  }
};
